import { ActionCreator } from '@sendoutcards/core'

export const checkoutOpenState = ActionCreator(
  'CHECKOUT_OPEN_STATE',
  (isCheckoutOpen: boolean) => ({ isCheckoutOpen }),
)
